import React from 'react';
import PropTypes from 'prop-types';
import CircleButton from './CircleButton';
import UserIcon from '../icons/UserIcon';
import sizes from './sizes';
const UserButton = ({ disabled, onClick, title, id, className, size, dataTestId, }) => {
    return (React.createElement(CircleButton, { id: id, size: size, className: className, color: "green", disabled: disabled, onClick: onClick, title: title, dataTestId: dataTestId || "userButton" },
        React.createElement(UserIcon, null)));
};
UserButton.propTypes = {
    id: PropTypes.string,
    size: PropTypes.oneOf(Object.values(sizes)),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string,
};
UserButton.defaultProps = {
    size: sizes.normal,
    disabled: false,
    title: '',
};
export default UserButton;
